import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { AiOutlineSave } from "react-icons/ai";
import Select from "react-select";
import { roles } from "../../constants/Roles";
import { CREATE_FORM_MUTATION } from "../../GraphQl/Mutations";
import { ALL_SURVEYORS } from "../../GraphQl/Queries";
import "../../styles/forms.css";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
const CreateForm = () => {
  const [surveyorList, setSurveyorList] = useState([]);
  const [formDetail, setFormDetail] = useState({});
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();
  const [createForm] = useMutation(CREATE_FORM_MUTATION, {
    variables: {
      formData: {
        formTitle: formDetail?.formTitle,
        description: formDetail?.description,
        formType: formDetail?.formType,
        surveyorId: formDetail?.surveyorId,
        adminId: localStorage.getItem("shub-userId"),
      },
    },
    onCompleted: (data) => {
      setMessage("Form created successfully!");
      console.log(data);
      setTimeout(() => {
        navigate(
          "/dashboard/manage-form/" + data?.createForm?._id + "/questions"
        );
      }, 500);
      setTrial(false);
    },
    onError: (err) => {
      setMessage(
        "Could not create form! Please check all fields and try again"
      );
      setTrial(false);
    },
  });
  const [getAllSurveyorList, { error, loading, data }] = useLazyQuery(
    ALL_SURVEYORS,
    {
      fetchPolicy: "cache-and-network",
      variables: {
        userType: roles.SURVEYOR,
      },
      onCompleted: (data) => {
        setSurveyorList(
          data.getAllUsers?.map((data) => {
            return {
              value: data._id,
              label: data?.fullName + " " + data?.email,
            };
          })
        );
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
  const options = [
    { value: "Survey", label: "Survey" },
    { value: "Quiz", label: "Quiz" },
    { value: "Feedback", label: "Feedback" },
    { value: "Marketing Survey", label: "Marketing Survey" },
  ];
  const [trial, setTrial] = useState(false);
  const styles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      width: "100%",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
    }),
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
  };
  useEffect(() => {
    getAllSurveyorList();
  }, []);
  const saveDetails = () => {
    setMessage(null);

    if (!formDetail?.formType) {
      setFormDetail({ ...formDetail, formType: "Survey" });
    }
    if (
      formDetail?.formTitle &&
      formDetail?.description &&
      formDetail?.formType &&
      formDetail?.surveyorId
    ) {
      setTrial(true);
      createForm();
    } else {
      if (!formDetail?.formTitle) setMessage("Please add a form title");
      if (!formDetail?.description) setMessage("Please add a description");
      if (!formDetail?.formType) setMessage("Please add a form type");
      if (!formDetail?.surveyorId) setMessage("Please select a surveyor");
    }
  };

  return (
    <div>
      <div className='sectionHeaderWrapper flex items-center content-between'>
        <div className='sectionHeaderTitle'> Create New Form </div>
      </div>
      <div className='sectionContentWrapper'>
        <div className='profileFormWrapper'>
          <div className='inputGroup flex items-center'>
            <div className='label'>Form Title</div>
            <input
              type='text'
              className='form-control'
              placeholder={"Enter form title"}
              onKeyUp={(e) =>
                setFormDetail({
                  ...formDetail,
                  formTitle: e.target.value,
                })
              }
            />
          </div>
          <div className='inputGroup flex items-center'>
            <div className='label'>Form Description</div>
            <textarea
              className='form-control'
              placeholder={"Enter form Description"}
              onKeyUp={(e) =>
                setFormDetail({
                  ...formDetail,
                  description: e.target.value,
                })
              }
            />
          </div>
          <div className='inputGroup flex items-center'>
            <div className='label'>Form Type</div>
            <Select
              defaultValue={options[0]}
              options={options}
              style={{ width: "min(500px,90vw)" }}
              styles={styles}
              onChange={(e) => {
                setFormDetail({
                  ...formDetail,
                  formType: e.value,
                });
              }}
            />
          </div>
          <div className='inputGroup flex items-center'>
            <div className='label'>Surveyor</div>
            <Select
              // defaultValue={surveyorList[0]}
              style={{ width: "min(500px,90vw)" }}
              styles={styles}
              options={surveyorList}
              isSearchable={true}
              isClearable={true}
              onChange={(e) => {
                setFormDetail({
                  ...formDetail,
                  surveyorId: e.value,
                });
              }}
            />
          </div>
        </div>
        <div
          className='profileEditBtn btn btn-primary flex items-center'
          onClick={() => {
            saveDetails();
          }}
        >
          <span>{trial ? <Loader color='#fff' /> : <AiOutlineSave />}</span>
          &nbsp;
          <span>Save</span>
        </div>
        <div className='messageDiv'>{message}</div>
      </div>
    </div>
  );
};

export default CreateForm;
